import React from "react";

export const SEARCH_MODE_KEYS = {
  maia: "maia",
  search: "search",
};

export const SEARCH_MODES = {
  [SEARCH_MODE_KEYS.maia]: {
    placeholder: "Ask Maia anything...",
    description: "AI-powered. Ask a question and get a direct answer.",
    icon: "far fa-arrow-up",
  },
  [SEARCH_MODE_KEYS.search]: {
    placeholder: "Search All myApplied",
    description: "Search the portal by keyword",
    icon: "far fa-search",
  },
};

const SearchModeToggle = ({ mode, onModeChange, className = "" }) => {
  const getButtonClass = (buttonMode) =>
    `relative z-1 flex-1 rounded-full border-none py-[6px] text-center font-default text-[14px] font-semibold leading-[22px] tracking-[0.2px] transition-colors duration-300 cursor-pointer bg-transparent ${
      mode === buttonMode ? "text-primary" : "text-white"
    }`;

  return (
    <div
      className={`relative isolate flex w-[140px] items-center rounded-[40px] bg-[#007983] px-[3px] py-[3px] ${className}`}
    >
      <div
        className={`absolute bottom-[3px] top-[3px] w-[calc(50%-3px)] rounded-full bg-white transition-transform duration-300 ease-in-out ${
          mode === SEARCH_MODE_KEYS.search
            ? "translate-x-[100%]"
            : "translate-x-0"
        }`}
        style={{ left: "3px" }}
      />
      <button
        type="button"
        onClick={() => onModeChange(SEARCH_MODE_KEYS.maia)}
        className={getButtonClass(SEARCH_MODE_KEYS.maia)}
        aria-pressed={mode === SEARCH_MODE_KEYS.maia}
      >
        Maia
      </button>
      <button
        type="button"
        onClick={() => onModeChange(SEARCH_MODE_KEYS.search)}
        className={getButtonClass(SEARCH_MODE_KEYS.search)}
        aria-pressed={mode === SEARCH_MODE_KEYS.search}
      >
        Search
      </button>
    </div>
  );
};

export default SearchModeToggle;
